import React from "react";
import Layout from "../../components/Layout";
import HeroSection from "../../components/HeroSection/HeroSection";
import { useTranslation } from "react-i18next";
import ReusableSlider from "../../components/ReusableSlider/ReusableSlider";
import { Helmet } from "react-helmet-async";

/*----- Hero images -----*/
import heroImage1 from "../../assets/images/great-hall/greatHall8.jpg";
import heroImage2 from "../../assets/images/great-hall/greatHall9.jpg";
import heroImage3 from "../../assets/images/great-hall/greatHall10.jpg";
import heroImage4 from "../../assets/images/great-hall/greatHall11.jpg";
import heroImage5 from "../../assets/images/great-hall/greatHall12.jpg";

/*----- Gallery images -----*/
import galleryImage1 from "../../assets/images/great-hall/greatHall13.jpg";
import galleryImage2 from "../../assets/images/great-hall/greatHall14.jpg";
import galleryImage3 from "../../assets/images/great-hall/greatHall15.jpg";
import galleryImage4 from "../../assets/images/great-hall/greatHall16.jpg";
import galleryImage5 from "../../assets/images/great-hall/greatHall17.jpg";
import galleryImage6 from "../../assets/images/great-hall/greatHall18.jpg";
import galleryImage7 from "../../assets/images/great-hall/greatHall19.jpg";
import galleryImage8 from "../../assets/images/great-hall/greatHall20.jpg";

const GreatHallGallery = [
  galleryImage1,
  galleryImage2,
  galleryImage3,
  galleryImage4,
  galleryImage5,
  galleryImage6,
  galleryImage7,
  galleryImage8,
];

export default function GreatHall() {
  const { t } = useTranslation(["great_hall", "links"]);
  return (
    <Layout>
      <Helmet>
        <title>Velika sala</title>
        <meta
          name="description"
          content={
            "Dobrodošli u našu veliku salu, idealno mesto za proslave, konferencije i posebne događaje. Naša sala je prostrana i može primiti do 400 ljudi, pružajući dovoljno prostora za vašu veliku grupu gostiju"
          }
        />
        <link rel="canonical" href={"https://vidovdanrestoran.rs/great-hall"} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={"Velika sala"} />
        <meta
          property="og:description"
          content={
            "Dobrodošli u našu veliku salu, idealno mesto za proslave, konferencije i posebne događaje. Naša sala je prostrana i može primiti do 400 ljudi, pružajući dovoljno prostora za vašu veliku grupu gostiju"
          }
        />
        <meta property="og:image" content={heroImage5} />
        <meta
          property="og:url"
          content={"https://vidovdanrestoran.rs/great-hall"}
        />
        <meta property="og:site_name" content="Vidovdan" />
        <meta property="og:locale" content="sr_RS" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={"Velika sala"} />
        <meta
          name="twitter:description"
          content={
            "Dobrodošli u našu veliku salu, idealno mesto za proslave, konferencije i posebne događaje. Naša sala je prostrana i može primiti do 400 ljudi, pružajući dovoljno prostora za vašu veliku grupu gostiju"
          }
        />
        <meta name="twitter:image" content={heroImage5} />
      </Helmet>
      <HeroSection
        images={[heroImage1, heroImage2, heroImage3, heroImage4, heroImage5]}
        title={t("great_hall_hero_title")}
        subTitle={t("great_hall_hero_subtitle")}
        description={t("great_hall_hero_description")}
      />
      <ReusableSlider
        slides={GreatHallGallery}
        title={t("great_hall_title")}
        description={t("great_hall_description")}
      />
    </Layout>
  );
}
